import StockInOut from './views/inventory/StockInOut';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import React, { useEffect } from 'react'
import './App.css'
import { NotificationProvider } from './Context/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from "./views/dashboard/dashboard";
import CashierDashboard from "./views/dashboard/cashierDashboard";
import CashierAnalytics from "./views/dashboard/CashierAnalytics";
import ClubStoreManagerDashboard from "./views/ClubStoreManagerDashboard";
import ClubStoreManagerReport from "./views/ClubStoreManagerReport";
import WarehouseStoreManagerDashboard from "./views/WarehouseStoreManagerDashboard";
import WarehouseStoreManagerReport from "./views/WarehouseStoreManagerReport";
import BarcodePayment from "./views/collection/BarcodePayment";
import ManualPayment from "./views/collection/ManualPayment";
import PaidAmounts from "./views/collection/PaidAmounts";
import PaidAmountSummary from "./views/collection/PaidAmountSummary";
import CounterClose from "./views/collection/CounterClose";
import CashierSummaries from "./views/collection/CashierSummaries";
import DayClose from "./views/collection/DayClose";
import CollectionSummary from "./views/collection/CollectionSummary";
import AccoiuntDashboard from "./views/dashboard/dashboardAccount";
import AnalyticsDashboard from "./views/dashboard/analyticsDashboard";
import AccountDashboard from "./views/accounts/AccountDashboard";

import AccessDenied from "./views/pages/accessDenied";

import NewPage from './views/pages/NewPage';
import PrivateRoute from './utility/PrivateRoute';
import Login from './views/pages/Login';
import Logout from './views/Logout';
import HotelBookingCalendar from './views/Hotel/HotelBookingCalendar';
import Details from './views/Hotel/Details';

import Customers from './views/master/customers';
import NewPromotors from './views/master/NewPromotors';
import PromoterEntry from './views/promoter/PromoterEntry';
import Suppliers from './views/master/suppliers';
import Categories from './views/master/categories';
import SubCategories from './views/master/subCategories';
import TableList from './views/master/newTable';
import PaymentOptions from './views/master/paymentOptions';
import ExpenseHead from './views/master/ExpenseHead';
import NewLedger from './views/master/NewLedger';
import MenuPricing from './views/menu/MenuPricing';
import BarManagement from './views/menu/BarManagement';
import FoodManagement from './views/menu/FoodManagement';

import NewItem from './views/inventory/newItem';
import EditItem from './views/inventory/editItem';
import NewProduct from './views/inventory/newProduct1';
import SponsorReports from './views/inventory/SponsorReports';
import StockReport from './views/inventory/stockReport';
import StockReportNew from './views/inventory/StockReportNew';
import ClosingStock from './views/inventory/ClosingStock';
import Assets from './views/inventory/Assets';


import AdvanceOrder from './views/pos/advanceorder';
import AdvanceOrdergstt from './views/pos/advanceOrderPosgst';
import NewPOS from './views/pos/newPOS';
import NewPOSGST from './views/pos/posGst';
import NewSale from './views/pos/sale';
import vatSale from './views/pos/vatsale';
import CancelBill from './views/pos/CancelBill';
import MoveBillToEntertainment from './views/pos/MoveBillToEntertainment';
//expenses
import SupplierLedgerEntry from './views/ledgers/supplierLedgerEntry';
import Expenses from './views/expensesbak/expenses';

//Vouchers
import Vouchers from './views/vouchers/vouchers';
import PaymentVouchers from './views/vouchers/paymentVouchers';
//Reports
import BillHistory from './views/reports/billHistory';
import BillHistoryGst from './views/reports/billHistorygst';
import AdvanceOrdergst from './views/reports/advanceOrdergst';
import AdvanceOrderReport from './views/reports/advanceorderReports';
import ItemWiseSaleGst from './views/reports/itemWiseSaleGst';
import ItemWiseSaleReport from './views/reports/ItemWiseSaleReport';
import BillWiseSale from './views/reports/BillWiseSale';
import DateWiseSale from './views/reports/DateWiseSale';
import SaleLedger from './views/reports/saleLedger';
import SupplierLedger from './views/reports/suppliersLedger';
import TableHistory from './views/collection/TableHistory';
import PromoterSummary from './views/reports/PromoterSummary';
import PromoterSummaryWithNshare from './views/reports/PromoterSummaryWithNshare';


//Users
import NewUser from './views/pages/users/NewUser';
import EditProfile from './views/profile/editprofile';
import LoginHistory from './views/pages/users/LoginHistory';


//settings
import CompanyInfo from './views/settings/companyInfo';
import CoreSetting from './views/settings/coreSetting';
import Taxes from './views/master/taxes';
import Units from './views/master/units';

//HR Management
import EmployeeMaster from './views/hr/EmployeeMaster';
import EmployeeDepartments from './views/hr/EmployeeDepartments';
import EmployeePositions from './views/hr/EmployeePositions';
import EmployeeRecords from './views/hr/EmployeeRecords';
import WorkSchedule from './views/hr/WorkSchedule';
import Payroll from './views/hr/Payroll';
import PayrollReports from './views/hr/PayrollReports';
import EmployeePayrollSystem from './views/hr/EmployeePayrollSystem';
import TaxCompliances from './views/hr/TaxCompliances';
import HRAnalyticsDashboard from './views/hr/HRAnalyticsDashboard';


function App() {
  
  // Global error handler to prevent unhandled rejections
  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the default behavior (which would log to console)
      event.preventDefault();
      
      // Optional: Show user-friendly notification
      if (event.reason && event.reason.message) {
        console.warn('Promise rejection handled:', event.reason.message);
      }
    };

    const handleError = (event) => {
      console.error('Global error:', event.error);
      // Don't prevent default for regular errors as they should still be logged
      
      // Optional: Track errors for debugging
      if (event.error && event.error.message) {
        console.warn('Global error handled:', event.error.message);
      }
    };

    // Add error listeners
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    // Cleanup function
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <ErrorBoundary>
      <NotificationProvider>
        <Router>
          <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/accessdenied" element={<AccessDenied />} />

          {/* Protected Routesgb ff */}
          <Route path="/master/newsupplier" element={<PrivateRoute><Suppliers /></PrivateRoute>} />
          <Route path="/master/newcustomer" element={<PrivateRoute><Customers /></PrivateRoute>} />
          <Route path="/master/newpromotor" element={<PrivateRoute><NewPromotors /></PrivateRoute>} />
          <Route path="/promoter/entry" element={<PrivateRoute><PromoterEntry /></PrivateRoute>} />
          <Route path="/master/newcategory" element={<PrivateRoute><Categories /></PrivateRoute>} />
          <Route path="/master/newsubcategory" element={<PrivateRoute><SubCategories /></PrivateRoute>} />
          <Route path="/master/table" element={<PrivateRoute><TableList /></PrivateRoute>} />
          <Route path="/master/paymentoptions" element={<PrivateRoute><PaymentOptions /></PrivateRoute>} />
          <Route path="/master/expensehead" element={<PrivateRoute><ExpenseHead /></PrivateRoute>} />
          <Route path="/master/newledger" element={<PrivateRoute><NewLedger /></PrivateRoute>} />
          <Route path="/menu/pricing" element={<PrivateRoute><MenuPricing /></PrivateRoute>} />
          <Route path="/menu/bar-management" element={<PrivateRoute><BarManagement /></PrivateRoute>} />
          <Route path="/menu/food-management" element={<PrivateRoute><FoodManagement /></PrivateRoute>} />

          <Route path="/inventory/newitem" element={<PrivateRoute><NewItem /></PrivateRoute>} />
          <Route path="/inventory/edititem/:id" element={<PrivateRoute><EditItem /></PrivateRoute>} />
          <Route path="/inventory/newproduct" element={<PrivateRoute><NewProduct /></PrivateRoute>} />
          <Route path="/inventory/sponsor-reports" element={<PrivateRoute><SponsorReports /></PrivateRoute>} />
          <Route path="/inventory/stockreports" element={<PrivateRoute><StockReport /></PrivateRoute>} />
          <Route path="/inventory/stock-report-new" element={<PrivateRoute><StockReportNew /></PrivateRoute>} />
          <Route path="/inventory/closing-stock" element={<PrivateRoute><ClosingStock /></PrivateRoute>} />
          <Route path="/inventory/assets" element={<PrivateRoute><Assets /></PrivateRoute>} />

          <Route path="/inventory/stockinout" element={<PrivateRoute><StockInOut /></PrivateRoute>} />

          
          <Route path="/sale/pos" element={<PrivateRoute><NewPOS /></PrivateRoute>} />
          <Route path="/sale/advanceorder" element={<PrivateRoute><AdvanceOrder /></PrivateRoute>} />
          <Route path="/sale/newsale" element={<PrivateRoute><NewSale /></PrivateRoute>} />
          <Route path="/sale/vatsale" element={<PrivateRoute><vatSale /></PrivateRoute>} />
          <Route path="/sale/advanceordergstt" element={<PrivateRoute><AdvanceOrdergstt /></PrivateRoute>} />
          
          <Route path="/sale/posgst" element={<PrivateRoute><NewPOSGST /></PrivateRoute>} />

          {/* Bill Management Routes */}
          <Route path="/bill-management/cancel-bill" element={<PrivateRoute><CancelBill /></PrivateRoute>} />
          <Route path="/bill-management/move-entertainment" element={<PrivateRoute><MoveBillToEntertainment /></PrivateRoute>} />
          

          <Route path="/expenses/suppliersexpenses" element={<PrivateRoute><SupplierLedgerEntry /></PrivateRoute>} />
         
          <Route path="/dashboard/admin" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard/analytics" element={<PrivateRoute><AnalyticsDashboard /></PrivateRoute>} />
          <Route path="/dashboard/cashier" element={<PrivateRoute><CashierDashboard /></PrivateRoute>} />
          <Route path="/dashboard/cashier/analytics" element={<PrivateRoute><CashierAnalytics /></PrivateRoute>} />
          <Route path="/dashboard/clubstoremanager" element={<PrivateRoute><ClubStoreManagerDashboard /></PrivateRoute>} />
          <Route path="/report/clubstoremanager" element={<PrivateRoute><ClubStoreManagerReport /></PrivateRoute>} />
          <Route path="/dashboard/warehousestoremanager" element={<PrivateRoute><WarehouseStoreManagerDashboard /></PrivateRoute>} />
          <Route path="/dashboard/warehousestoremanager/report" element={<PrivateRoute><WarehouseStoreManagerReport /></PrivateRoute>} />
          <Route path="/collection/barcode-payment" element={<PrivateRoute><BarcodePayment /></PrivateRoute>} />
          <Route path="/collection/manual-payment" element={<PrivateRoute><ManualPayment /></PrivateRoute>} />
          <Route path="/collection/paid-amounts" element={<PrivateRoute><PaidAmounts /></PrivateRoute>} />
          <Route path="/collection/paid-summary" element={<PrivateRoute><PaidAmountSummary /></PrivateRoute>} />
          <Route path="/collection/counter-close" element={<PrivateRoute><CounterClose /></PrivateRoute>} />
          <Route path="/collection/day-close" element={<PrivateRoute><DayClose /></PrivateRoute>} />
          <Route path="/collection/summary" element={<PrivateRoute><CollectionSummary /></PrivateRoute>} />
          <Route path="/reports/cashier-summaries" element={<PrivateRoute><CashierSummaries /></PrivateRoute>} />
          <Route path="/dashboard/account" element={<PrivateRoute><AccoiuntDashboard /></PrivateRoute>} />
          <Route path="/accounts/dashboard" element={<PrivateRoute><AccountDashboard /></PrivateRoute>} />
        
        
          <Route path="/users/newuser" element={<PrivateRoute><NewUser /></PrivateRoute>} />
          <Route path="/users/editprofile" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
          <Route path="/users/login-history" element={<PrivateRoute><LoginHistory /></PrivateRoute>} />

          {/* Vouchers */}
          <Route path="/vouchers/recieptvoucher" element={<PrivateRoute><Vouchers /></PrivateRoute>} />
          <Route path="/vouchers/paymentvoucher" element={<PrivateRoute><PaymentVouchers /></PrivateRoute>} />

          {/* Ledgers */}
          <Route path="/ledgers/general-entry" element={<PrivateRoute><SupplierLedgerEntry /></PrivateRoute>} />
          <Route path="/ledgers/suppliersledger" element={<PrivateRoute><SupplierLedger /></PrivateRoute>} />
          <Route path="/ledgers/customerledger" element={<PrivateRoute><SaleLedger /></PrivateRoute>} />

          {/* Reports */}
          <Route path="/reports/billhistory" element={<PrivateRoute><BillHistory /></PrivateRoute>} />
         
          <Route path="/reports/table-history" element={<PrivateRoute><TableHistory /></PrivateRoute>} />

           <Route path="/reports/advanceorderreportgst" element={<PrivateRoute><AdvanceOrdergst /></PrivateRoute>} />
           <Route path="/reports/advanceorderreport" element={<PrivateRoute><AdvanceOrderReport /></PrivateRoute>} />
           <Route path="/reports/billhistorygst" element={<PrivateRoute><BillHistoryGst /></PrivateRoute>} />
          <Route path="/reports/itemwisesale" element={<PrivateRoute><ItemWiseSaleGst /></PrivateRoute>} />
          <Route path="/reports/itemwisesalegst" element={<PrivateRoute><ItemWiseSaleGst /></PrivateRoute>} />
          <Route path="/reports/item-wise-sale-report" element={<PrivateRoute><ItemWiseSaleReport /></PrivateRoute>} />
          <Route path="/reports/bill-wise-sale" element={<PrivateRoute><BillWiseSale /></PrivateRoute>} />
          <Route path="/reports/date-wise-sale" element={<PrivateRoute><DateWiseSale /></PrivateRoute>} />
          <Route path="/reports/promoter-summary" element={<PrivateRoute><PromoterSummary /></PrivateRoute>} />
          <Route path="/reports/promoter-summary1" element={<PrivateRoute><PromoterSummaryWithNshare /></PrivateRoute>} />

          {/* HR Management */}
          <Route path="/hr/employee-master" element={<PrivateRoute><EmployeeMaster /></PrivateRoute>} />
          <Route path="/hr/employee-records" element={<PrivateRoute><EmployeeRecords /></PrivateRoute>} />
          <Route path="/hr/departments" element={<PrivateRoute><EmployeeDepartments /></PrivateRoute>} />
          <Route path="/hr/positions" element={<PrivateRoute><EmployeePositions /></PrivateRoute>} />
          <Route path="/hr/work-schedule" element={<PrivateRoute><WorkSchedule /></PrivateRoute>} />
          <Route path="/hr/payroll-management" element={<PrivateRoute><Payroll /></PrivateRoute>} />
          <Route path="/hr/payroll-reports" element={<PrivateRoute><PayrollReports /></PrivateRoute>} />
          <Route path="/hr/employee-payroll-system" element={<PrivateRoute><EmployeePayrollSystem /></PrivateRoute>} />
          <Route path="/hr/tax-compliances" element={<PrivateRoute><TaxCompliances /></PrivateRoute>} />
          <Route path="/hr/analytics-dashboard" element={<PrivateRoute><HRAnalyticsDashboard /></PrivateRoute>} />

          {/* Settings - Unprotected (or protect if needed) */}
          <Route path="/setting/companyinfo" element={<CompanyInfo />} />
          <Route path="/setting/coresetting" element={<CoreSetting />} />
          <Route path="/setting/taxes" element={<Taxes />} />
          <Route path="/setting/units" element={<Units />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
